import React, {Component} from "react";
import begin1a from '../../../../../assets/img/begin1a.png';
import begin2new from '../../../../../assets/img/begin2new.png';
import begin3new from '../../../../../assets/img/begin3new.png';
import begin4new from '../../../../../assets/img/begin4new.png';
import begin5new from '../../../../../assets/img/begin5new.png';
import begin6new from '../../../../../assets/img/begin6new.png';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import img1 from "../../../../../assets/img/kitcut-footer--pages-images/page5-1.png";
import img2a from "../../../../../assets/img/kitcut-footer--pages-images/page5-2a.png";
import img2b from "../../../../../assets/img/kitcut-footer--pages-images/page5-2b.png";
import img3 from "../../../../../assets/img/kitcut-footer--pages-images/page5-3.png";
import '../FooterNavPages/FooternavPages.css'

class Page5 extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }

    render() {
        return (
            <div className="faq-page-layout">
                <div className="beginners-background-div footer-nav-pages-background">

                    <h3 className='font-size-30 yu-gothic-bold '>
                        KiCad ガーバーデータ出力方法
                    </h3>
                    <br/>
                    <p className='all-content-font-size3'>
                        <b>ドリルファイルとガーバーファイルを作成する </b>
                    </p>
                    <p className='all-content-font-size'>
                        メニューから「File」 ＝＞「Plot」を選択して、<b>「製造ファイル出力」</b>ダイアログが表示されるので、各項目を指定します。
                    </p>
                    <br/>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav" src={img1} alt=""/>
                    </p>
                    <br/>
                    <p className='all-content-font-size'>
                        「出力フォーマット：」で「Gerber」を選択します。
                        <br/>
                        「出力ディレクトリ：」を任意の場所に指定します。
                        <br/>
                        次に「レイヤー」項目にチェックを入れます。
                    </p>

                    <p className='all-content-font-size'>
                        <b> ドリルファイル</b>

                    </p>
                    <div className='col-md-12'>
                        <div className='col-md-4'>
                            <p className='all-content-font-size '>
                                <img className="img-size-footer-nav-table" src={img2a} alt=""/>
                            </p>
                        </div>

                        <div className='col-md-8'>
                            <ul className="page-5-resp-list">
                                <li> パターン層（F.Cu、B.Cuなど）
                                </li>
                                <li> シルク層（F.SilkS、B.SilkS）
                                </li>
                                <li> レジスト層（F.Mask、B.Mask）
                                </li>
                                <li> 基板外形層（Edge.Cuts）
                                </li>
                                <li> その他必要な層（メタルマスク、寸法線指示などがある場合）
                                </li>
                            </ul>

                        </div>

                    </div>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav" src={img2b} alt=""/>
                    </p>
                    <br/>

                    <p className='all-content-font-size'>
                        ガーバー出力ダイアログにて <b> 「ドリルファイルの生成」 </b>ボタンをクリックします。
                        <br/>
                        下記のダイアログが表示されるので、各項目を設定します。
                        <br/>
                        <b>「ドリル ファイル」「マップ ファイル」「レポート ファイル」</b>ボタンをクリックして、各ファイルの生成後に「閉じる」ボタンをクリックして終了します。
                    </p>
                    <br/>
                    <p className='all-content-font-size '>
                        <img className="img-size-footer-nav" src={img3} alt=""/>
                    </p>
                    <br/>

                    <p className='all-content-font-size'>
                        <b> GerbViewのGerberファイルを確認してください。</b>
                    </p>

                    <p className='all-content-font-size'>
                        作成したガーバー/ドリルデータの確認が出来ます。
                        <br/>
                        KiCadのプロジェクト管理画面より<b>「GerbView（ガーバービューア）」</b>をクリックしてください。<br className="responsive-break"/>
                        メニューより、<b>「File（ファイル）」→「ガーバーファイルを読み込む（G）」</b>または<b>「EXCELLON ドリルファイルを読み込む（E）」</b>をクリックし、
                        <br/>
                        読み込むファイルを選択すると、ガーバーデータ、ドリルデータが表示されます。<br/>
                        画面右の各レイヤーのチェックをオン/オフすることで、層ごとに表示を確認できます。
                    </p>
                    <br className="responsive-break"/>
                    <p className='all-content-font-size'>
                        確認後、それらのファイルを圧縮してKITCUT PCB 注文ページにてアップロードします。

                    </p>



                </div>
            </div>
        );
    }
}

export default Page5;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/FooterNavPages/page5.js